import React from 'react';
import { Card, Colors } from '@blueprintjs/core';
import DevText from '@app/components/Text';
import RouterLink from '@app/components/RouterLink';
import { Endpoints } from '@app/data/consts';
import {
    NotificationResource,
    TaskMessageResource,
} from 'dy-frontend-http-repository/lib/modules/Notification/resources';
import RichText from '@app/components/RichText';
import { UserUtils } from '@containers/components/Notifications/utils';
import NotificationTemplate from '../../../NotificationTemplate';

export interface TaskMessagePinnedNotificationProps {
    authorizedUserId: ID;
    notification: NotificationResource;
    taskMessage: TaskMessageResource | null;
    dismiss: () => Promise<void>;
}

export type Props = TaskMessagePinnedNotificationProps;

const TaskMessagePinnedNotification: React.FC<Props> = ({ authorizedUserId, notification, taskMessage, dismiss }) => {
    const renderContent = () => {
        if (!taskMessage) {
            // This is bad, task message is NOT found, which should not happen
            return <DevText color={Colors.RED2}>Message was not found</DevText>;
        }

        return (
            <div>
                <DevText running className="mb-1">
                    {UserUtils.getActorUserName(notification.activity.actor_user, authorizedUserId)} pinned message for{' '}
                    <RouterLink
                        style={{ display: 'inline' }}
                        to={Endpoints.TASK_INFORMATION.replace(':taskId', taskMessage.task.id)}
                    >
                        {taskMessage.task.title}
                    </RouterLink>
                </DevText>

                <Card compact>
                    <RichText value={taskMessage.content} />
                </Card>
            </div>
        );
    };

    return (
        <NotificationTemplate
            title="Message pinned"
            icon="pin"
            at={notification.activity.at}
            content={renderContent()}
            dismiss={dismiss}
        />
    );
};

export default TaskMessagePinnedNotification;
